import React, {useState} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import TextInput from "../../ui/textInput";
import {updateFeatureInfoCount} from "../../../actions/actionFunctions";
import {EditIcon, GroheInkPenIcon} from "../../common/icons";
import COLOR_THEMES from "../../../colorThemes";
import {IS_QKB_UI} from "../../../config";

const FeaturePriceInput = (props) => {

  const {feature, updateFeatureInfoCount, fabricatorData, unit, activeTheme, price, className, showPrice} = props;
  const fabricatorSettings = fabricatorData.settings;

  const [priceEditing, setPriceEditing] = useState(false);

  const hidePrice = (typeof showPrice !== 'undefined') && !showPrice;

  const togglePriceEditing = () => setPriceEditing(!priceEditing);

  // if (selectionFeatureInfo && selectionFeatureInfo.dbFeature.id && document.kvConfig.isBackend) {
  //   return <FeatureInfoPriceInput/>
  // }

  const handlePriceOnChange = (newAmount) => {
    if (fabricatorSettings.useFabricatorCostPrices) {
      feature.dbFeature.price = newAmount;
    } else {
      feature.dbFeature.cost = newAmount;
      feature.dbFeature.fabricatorCost = newAmount;
    }
    feature.dbFeature.priceWasChanged = true;
    updateFeatureInfoCount();
  }

  const displayPrice = feature.dbFeature.priceWasChanged
    ? fabricatorSettings.useFabricatorCostPrices ? feature.dbFeature.price : feature.dbFeature.cost
    : price; // display dbFeature changed price always, as it might be changed from complex logic

  return (
    <div className={"product-info__edit" + (className ? " " + className : "")}>
      {hidePrice ? null :
        <span className={IS_QKB_UI ? "product-info__price-new bold" : ""}>{fabricatorSettings.currencySign}</span>}
      <TextInput className={"ui-input ui-input--new product-info__edit-input"
        + (priceEditing ? " product-info__edit-input--visible" : "")}
                 numberInput={true}
                 autoComplete={"off"}
                 id="product-info-input"
                 onChange={handlePriceOnChange}
                 onBlur={togglePriceEditing}
                 onRealChange={handlePriceOnChange}
                 value={displayPrice}/>
      {priceEditing || hidePrice
        ? null
        : IS_QKB_UI ? <span className="product-info__price-new bold product-info__edit-price">{displayPrice}</span> : displayPrice}
      {unit && !hidePrice ? <span className="product-info__price-new bold">({unit})</span> : null}
      <label htmlFor="product-info-input"
             style={hidePrice ? {marginLeft: 0} : null}
             className="product-info__edit-icon"
             onClick={togglePriceEditing}>
        {IS_QKB_UI
          ? <EditIcon color={COLOR_THEMES[activeTheme].active}/>
          : <GroheInkPenIcon color={COLOR_THEMES[activeTheme].active}/>}
      </label>
    </div>
  )
};

FeaturePriceInput.propTypes = {
  feature: PropTypes.object,
  onBlur: PropTypes.func,
  unit: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  showPrice: PropTypes.bool,
};

const mapStateToProps = (store, ownProps) => {
  const {activeTheme} = store.serverState;
  return {
    feature: ownProps.feature || store.selectionState.selectionFeatureInfo,
    fabricatorData: store.fabricatorState,
    featureInfoCount: store.selectionState.featureInfoCount,
    activeTheme,
  };
};

const mapDispatchToProps = {
  updateFeatureInfoCount
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturePriceInput)
);
